import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import classes from "./spinner.module.css";
import PropTypes from "prop-types";

const Spinner = ({ styleClass }) => {
   return (
      <div className={styleClass ?? ""}>
         <Box className={classes.container}>
            <CircularProgress />
         </Box>
      </div>
   );
};

Spinner.propTypes = {
   styleClass: PropTypes.string,
};

export default Spinner;
